// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thsj-tj[data-v-508b8a90]{font-size:18px}.text-title[data-v-508b8a90]{margin-top:6px;color:rgba(0,0,0,.5);display:block}.title[data-v-508b8a90]{padding:15px 10px 0 10px}.bnd[data-v-508b8a90]{position:absolute;top:10px;color:rgba(0,0,0,.5)}.b-l[data-v-508b8a90]{border-left:1px solid rgba(0,0,0,.1)}.lygk[data-v-508b8a90]{width:100%;width:800px;display:-webkit-box;display:-ms-flexbox;display:flex}.lygk[data-v-508b8a90],.o-a[data-v-508b8a90]{overflow:auto}", ""]);
// Exports
module.exports = exports;
